const offerBar = document.querySelector('[data-zentrobad-offer-bar]');

if (offerBar instanceof HTMLElement) {
  const version = offerBar.dataset.version || 'current';
  const storageKey = `zentrobad-offer-dismissed:${version}`;
  let dismissed = false;

  try {
    dismissed = window.localStorage.getItem(storageKey) === '1';
  } catch {}

  if (dismissed) {
    offerBar.remove();
  } else {
    offerBar.querySelector('[data-zentrobad-offer-dismiss]')?.addEventListener('click', () => {
      try {
        window.localStorage.setItem(storageKey, '1');
      } catch {}
      offerBar.remove();
      window.dispatchEvent(new Event('resize'));
    });
  }
}
